import {
  AllowedGroundingFiles,
  ChatApi,
  ChatThreadModel,
  InitOverrideFunction,
  OnPostChatRequest,
  OnPostChatWithFileRequest,
} from "../../../@api";

export class ChatApiService
  implements Omit<ChatApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: ChatApi) {}

  public async onPostChat(requestParameters: OnPostChatRequest = {}): Promise<ChatThreadModel> {
    return this.api.onPostChat(requestParameters);
  }

  public async onPostChatWithFile(requestParameters: OnPostChatWithFileRequest = {}): Promise<ChatThreadModel> {
    return this.api.onPostChatWithFile(requestParameters);
  }

  public async chatGetAllowedGroundingFiles(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<AllowedGroundingFiles> {
    return this.api.chatGetAllowedGroundingFiles(initOverrides);
  }
}
